import SignaturePad from 'signature_pad';
import template from './signature-item.draw.html';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.page.signature-block.signature-item.draw',
    []
  )
  .component('tcSignatureItemDraw', {
    //tc-signature-item-draw
    template,
    bindings: {
      me: '<',
      data: '<',
      disabled: '<?',
    },
    controller: function ($scope, $element, $filter, $q) {
      var canvas = $element.find('canvas')[0];

      if (!this.disabled) {
        this.signaturePad = new SignaturePad(canvas);
      }

      const getPicture = () => {
        return $q((resolve, reject) => {
          if (this.signaturePad.isEmpty()) return reject('No data');
          resolve(this.signaturePad.toDataURL());
          this.signaturePad.clear();
        });
      };

      this.sign = () => {
        if (this.disabled) return;
        getPicture().then((picture) => {
          this.data.date = $filter('date')(new Date(), 'medium');
          this.data.picture = picture;
          this.data.drawSigned = true;
          this.data.ip = this.me.privateData.ip;
        });
      };

      this.reset = function () {
        if (this.disabled) return;
        this.signaturePad.clear();
        this.data.drawSigned = false;
        this.data.picture = null;
      };

      this.cancel = () => {
        if (this.disabled) return;
        this.reset();
        this.data.state = 'initial';
      };
    },
  }).name;
